export const sections = [
  {
    title: "MISIÓN",
    text: "Transformar la infraestructura hídrica en beneficio de la población; ampliando la cobertura y efectividad de nuestros servicios en el ámbito rural y urbano, satisfaciendo las demandas presentes y futuras del agua (vital líquido) y de los sistemas de alcantarillado, con la finalidad de garantizar el bienestar de las y los hidalguenses.",
  },
  {
    title: "VISIÓN",
    text: "Ser un Organismo que cumpla, sin distinción alguna y de forma incluyente, las necesidades de la ciudadanía en temas de agua potable, drenaje y alcantarillado; brindando un servicio de calidad, cercano, justo y honesto, en beneficio de toda la población, y así generar el Hidalgo que todas y todos queremos.",
  },
];